"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExpiryTypedStorage = void 0;
var react_1 = require("react");
var useExpiryStorage_1 = require("../useExpiryStorage");
function useExpiryTypedStorage(stroage, key, options) {
    var _a = options || {}, _b = _a.encoder, encoder = _b === void 0 ? function () { return 'null'; } : _b, _c = _a.decoder, decoder = _c === void 0 ? function () { return null; } : _c, _d = _a.defaultValue, defaultValue = _d === void 0 ? null : _d, _e = _a.defaultExpiry, defaultExpiry = _e === void 0 ? undefined : _e;
    var _f = (0, useExpiryStorage_1.useExpiryStorage)(stroage, key, encoder(defaultValue), defaultExpiry), value_ = _f[0], set_ = _f[1], a = _f[2], b = _f[3];
    var value = (0, react_1.useMemo)(function () { return decoder(value_); }, [value_]);
    var set = function (v) {
        var newValue = typeof v !== 'function' ?
            encoder(v) :
            encoder(v(value));
        set_(newValue);
    };
    return [value, set, a, b];
}
exports.useExpiryTypedStorage = useExpiryTypedStorage;
//# sourceMappingURL=index.js.map